import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "toastification" };
const _hoisted_2 = { class: "d-flex align-items-start" };
const _hoisted_3 = { class: "d-flex flex-grow-1 mt-1" };
const _hoisted_4 = ["textContent"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
    key: 0,
    class: "text-body bi bi-x-lg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: _normalizeClass(["me-3 flex-shrink-0 rounded-circle px-2 py-1", `bg-${_ctx.variant}`])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass([_ctx.icon, "text-white"])
                }, null, 2)
            ], 2),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                    (_ctx.title)
                        ? (_openBlock(), _createElementBlock("h5", {
                            key: 0,
                            class: _normalizeClass([`text-${_ctx.variant}`, "font-weight-bold toastification-title"]),
                            textContent: _toDisplayString(_ctx.title)
                        }, null, 10, _hoisted_4))
                        : _createCommentVNode("", true),
                    (_ctx.text)
                        ? (_openBlock(), _createElementBlock("small", {
                            key: 1,
                            class: "d-inline-block text-body",
                            innerHTML: _ctx.text
                        }, null, 8, _hoisted_5))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", {
                    class: "cursor-pointer toastification-close-icon ms-auto",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close-toast')))
                }, [
                    (!_ctx.hideClose)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
